/**
 * 内蒙古工匠系站点皮肤（同一套 UI，按 siteId 换图/视频）
 * 126 赤峰玉龙工匠 / 128 乌海工匠 / 129 呼和浩特青城工匠
 * 130 包头工匠 / 131 伊金霍洛旗工匠 / 132 阿拉善工匠
 *
 * 换资源：src/assets/themes/{siteId}/
 *   logo.png / banner.png / bg.png / m-logo.png
 * 首屏视频：配置 heroVideo（CDN mp4 地址）；留空则用 banner 图
 *
 * 选肤优先级：当前域名 > 传入 siteId（避免 localStorage 串站默认出赤峰图）
 */

import { getRequestHost } from "@/utils/axios";

export const NM_THEME_SITE_IDS = [126, 128, 129, 130, 131, 132];

export const NM_THEME_HOSTS = [
  "cfylgj.kskstudy.com", // 126 赤峰
  "whgjpy.kskstudy.com", // 128 乌海
  "qcgjpy.kskstudy.com", // 129 呼和浩特青城
  "btgjpy.kskstudy.com", // 130 包头
  "yjhlqgj.kskstudy.com", // 131 伊金霍洛旗
  "alsgjpy.kskstudy.com", // 132 阿拉善
];

/** host → siteId，线上首屏据此选肤，不依赖接口 / localStorage */
export const NM_HOST_TO_SITE_ID = {
  "cfylgj.kskstudy.com": 126,
  "whgjpy.kskstudy.com": 128,
  "qcgjpy.kskstudy.com": 129,
  "btgjpy.kskstudy.com": 130,
  "yjhlqgj.kskstudy.com": 131,
  "alsgjpy.kskstudy.com": 132,
};

const themes = {
  126: {
    siteId: 126,
    name: "赤峰玉龙工匠",
    logoAlt: "赤峰玉龙工匠人才培育平台",
    bannerAlt: "赤峰玉龙工匠人才培育线上学习平台",
    logo: require("@/assets/themes/126/logo.png"),
    // banner: require("@/assets/themes/126/banner.png"),
    banner: '',
    bg: require("@/assets/themes/126/bg.png"),
    mLogo: require("@/assets/themes/126/m-logo.png"),
    // 有视频填 CDN 地址，例如：'https://video.kjcxchina.com/sv/xxx.mp4'
    heroVideo: "https://video.kjcxchina.com/sv/17ea0624-1a11aae6edf/17ea0624-1a11aae6edf.mp4",
  },
  128: {
    siteId: 128,
    name: "乌海工匠",
    logoAlt: "乌海工匠人才培育平台",
    bannerAlt: "乌海工匠人才培育线上学习平台",
    logo: require("@/assets/themes/128/logo.png"),
    // banner: require("@/assets/themes/128/banner.png"),
    banner: '',
    bg: require("@/assets/themes/128/bg.png"),
    mLogo: require("@/assets/themes/128/m-logo.png"),
    heroVideo: "https://video.kjcxchina.com/sv/7a8156b-1a0ec77f13f/7a8156b-1a0ec77f13f.mp4",
  },
  129: {
    siteId: 129,
    name: "呼和浩特青城工匠",
    logoAlt: "呼和浩特青城工匠人才培育平台",
    bannerAlt: "呼和浩特青城工匠人才培育线上学习平台",
    logo: require("@/assets/themes/129/logo.png"),
    // banner: require("@/assets/themes/129/banner.png"),
    banner: '',
    bg: require("@/assets/themes/129/bg.png"),
    mLogo: require("@/assets/themes/129/m-logo.png"),
    heroVideo: "https://video.kjcxchina.com/sv/3f4ba23f-1a0ec77d37d/3f4ba23f-1a0ec77d37d.mp4",
  },
  130: {
    siteId: 130,
    name: "包头工匠",
    logoAlt: "包头工匠人才培育平台",
    bannerAlt: "包头工匠人才培育线上学习平台",
    logo: require("@/assets/themes/130/logo.png"),
    // banner: require("@/assets/themes/130/banner.png"),
    bg: require("@/assets/themes/130/bg.png"),
    mLogo: require("@/assets/themes/130/m-logo.png"),
    heroVideo: "https://video.kjcxchina.com/sv/2c634d5-1a11aae87bc/2c634d5-1a11aae87bc.mp4",
  },
  131: {
    siteId: 131,
    name: "伊金霍洛旗工匠",
    logoAlt: "伊金霍洛旗工匠人才培育平台",
    bannerAlt: "伊金霍洛旗工匠人才培育线上学习平台",
    logo: require("@/assets/themes/131/logo.png"),
    banner: require("@/assets/themes/131/banner.png"),
    bg: require("@/assets/themes/131/bg.png"),
    mLogo: require("@/assets/themes/131/m-logo.png"),
    heroVideo: "https://video.kjcxchina.com/sv/4b8e194e-1a11ab901a6/4b8e194e-1a11ab901a6.mp4",
  },
  132: {
    siteId: 132,
    name: "阿拉善工匠",
    logoAlt: "阿拉善工匠人才培育平台",
    bannerAlt: "阿拉善工匠人才培育线上学习平台",
    logo: require("@/assets/themes/132/logo.png"),
    // banner: require("@/assets/themes/132/banner.png"),
    banner: '',
    bg: require("@/assets/themes/132/bg.png"),
    mLogo: require("@/assets/themes/132/m-logo.png"),
    heroVideo: "https://video.kjcxchina.com/sv/4c1e2ff7-1a11abd41fb/4c1e2ff7-1a11abd41fb.mp4",
  },
};

export function isNmThemeSite(siteId) {
  return NM_THEME_SITE_IDS.includes(Number(siteId));
}

export function isNmThemeHost(host) {
  return NM_THEME_HOSTS.includes(host);
}

/**
 * 解析 NM 皮肤 siteId：当前域名优先，避免串站 localStorage 先画出赤峰图
 * @returns {number|null}
 */
export function resolveNmSiteId(siteId) {
  try {
    const host = getRequestHost();
    if (NM_HOST_TO_SITE_ID[host] != null) return NM_HOST_TO_SITE_ID[host];
  } catch (e) {
    /* ignore */
  }
  const id = Number(siteId);
  if (NM_THEME_SITE_IDS.includes(id)) return id;
  return null;
}

/** @returns {typeof themes[126]|null} */
export function getNmTheme(siteId) {
  const id = resolveNmSiteId(siteId);
  return id != null ? themes[id] : null;
}

export default themes;
